<template>
      <div>
          <div class="row" v-for="item in items" :key="item._id">
	          <div class="container">
	              <WhatsonRow :item="item" />
	          </div>
          </div>
      </div>
</template>

<script>
import WhatsonRow from './WhatsonRow';

export default {
    props: ['items'],
    components: {
        WhatsonRow
    }
}
</script>

<style scoped>
.row {
	margin-top: 2em;
  margin-bottom: 0;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #E6e6e6;
}
.row:first-of-type {
  margin-top: 0;
}
.row:last-of-type {
  margin: none;
  padding: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/cards/WhatsonRows.vue